import './styles.css';
import type { ComponentProps, FC } from 'react';
import { cn } from '@/shared/styles/utils.ts';

interface Props extends ComponentProps<'div'> {
  size?: number;
  light?: boolean;
  narrow?: boolean;
}

export const Spinner: FC<Props> = ({
  size = 80,
  light = false,
  narrow = false,
  ...props
}) => (
  <div style={{ width: `${size}px`, height: `${size}px` }} {...props}>
    <div className={cn('lds-ring', { light }, { narrow })}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
);
